<template>
  <div>
    <div class="text-lg font-semibold text-content">
      <slot />
    </div>
    <div class="text-sm text-gray-500">
      <slot name="subtitle" />
    </div>
  </div>
</template>
